import { enqueueSnackbar as _enqueueSnackbar } from '@marpla/ui/components/SnackbarProvider';
import { type SnackbarKey } from 'notistack';

export const enqueueSnackbar = (...args): SnackbarKey | undefined => {
  const [message, options] = args.length === 2 ? args : [args[0]?.message, args[0]];

  return _enqueueSnackbar(message, {
    ...options,
    className: `toast-${options?.variant || 'default'} ${options?.className || ''}`,
  });
};
